import api from "./api";

export const getBillingRecords = (params = {}) =>
  api.get("/billing/records/", { params });

export const createBillingRecord = (data) =>
  api.post("/billing/records/", data);

// BILLING_STAFF only — advances submission_status; may update notes
export const updateBillingRecord = (id, data) =>
  api.patch(`/billing/records/${id}/`, data);

// BILLING_STAFF only — aggregate stats (total_billed, total_paid, count_by_status, count_by_payor_type)
export const getBillingReport = (params = {}) =>
  api.get("/billing/reports/", { params });

// Used for patient and provider selectors — supports ?role= filter
export const getUsers = (params = {}) =>
  api.get("/accounts/users/", { params });
